import { DEFAULT_LOCALE } from "../config";
import { useLocaleCookie } from "./use-locale-cookie";

export default function useLocale() {
  const { setLocaleCookie, localeCookie } = useLocaleCookie();

  return {
    locale: localeCookie ?? DEFAULT_LOCALE,
    setLocale: setLocaleCookie,
  };
}
